<template>
	<div class="prd">
		<div class="choose" @click="check">
			<div class="circle" v-if="!isShow"></div>
			<i class="el-icon-success green" v-if="isShow"></i>
			<div class="top-text" v-if="tophandle >0">置顶</div>
		</div>
		<div class="content">
			<div class="img-box">
				<img :src="thumbnails[0].url" class="img" v-if="thumbnails && thumbnails.length" />
			</div>
			<div class="right-text">
				<div class="name" :title="name">{{ name }}</div>
				<div class="weight">排序:{{ weight }}</div>
			</div>
		</div>
		<div class="toSkip"><span @click="toSkip" class="showPage">查看页面</span></div>
	</div>
</template>

<script>
export default {
	props: {
		value: null,
		id: null,
		name: null,
		istop: null,
		path: null,
		weight: null,
		thumbnails: null,
	},
	data() {
		return {};
	},
	components: {},
	computed: {
		tophandle()
		{
			let flag=typeof(this.istop)=='number'?this.istop:Number(this.istop);
			return flag ||0;
		},
		isShow() {
			let flag = this.value.some(item => {
				return this.id == item.productId;
			});
			return flag;
		},
		queryParam() {
			return this.$route.query;
		},
		pathUrl() {
			return this.path?'https://'+this.queryParam.name+this.path:'https://'+this.queryParam.name;
		},
	
	},
	methods: {
		toSkip() {
			window.open(this.pathUrl);
		},
		check() {
			//domain域名  explain说明 imgPath图片链接 pagePath页面链接地址 productId产品ID productTypeId 产品分类ID title
			let imgurl = this.thumbnails && this.thumbnails.length ? this.thumbnails[0].url : '';
			let domain= 'https://'+this.queryParam.name;
			let pagePath=this.path?'https://'+this.queryParam.name+this.path:'https://'+this.queryParam.name;
			this.$emit('check', {
				domain:domain,
				explain:"",
				imgPath: imgurl,
				pagePath: pagePath,
				productId: this.id,
				productTypeId:"",
				title: this.name,
				
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.prd {
	padding: 10px 15px;
	height: 135px;
	background: #ffffff;
	box-shadow: 0px 1px 6px 0px rgba(51, 51, 51, 0.1);
	border-radius: 4px;
}
.prd:hover{
	background-color: #EDF5FE  ;
}
.choose {
	display: flex;
	justify-content: space-between;
	cursor: pointer;
	text-align: center;
	.circle {
		width: 16px;
		height: 16px;
		border: 1px solid #e9e9e9;
		border-radius: 8px;
	}
	.green {
		color: #34d04c;
		font-size: 16px;
	}
	.top-text {
		color: #666666;
		font-size: 12px;
	}
}
.content {
	margin-top: 10px;
	display: flex;
	.img-box {
		width: 70px;
		height: 70px;
	}
	.img {
		width: 70px;
		height: 70px;
		border-radius: 2px;
	}
	.right-text {
		flex:1;
		font-weight: 400;
		color: #4a4a4a;
		font-size: 14px;
		padding-left: 10px;
		position: relative;

		.name {
			width: 100%;
			height: 34px;
			word-break: break-all;
			display: -webkit-box;
			overflow: hidden;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
		.weight {
			margin-top: 10px;
		}
	}
}
.toSkip {
	font-weight: 400;
	color: #3da1ff;
	font-size: 14px;
	text-align: right;
}
.showPage {
	cursor: pointer;
}
</style>
